import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";
import { t } from '../../i18n';

export class RiskAssessmentProcedure extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'riskAssessment'}
            title={ t('support.procedure.P16.title') }
            exportTitle={ t('support.procedure.P16.exportTitle') }
            exportFileName={'risk_assessment.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (RiskAssessmentProcedure);
